import { LoadingOverlay, Tabs } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../../_base/extension/StringExtension";
import { getDataDetailProduct } from "../../../../api/ApiProduct";
import { useProductCreateStore } from "../../../../store/useProductCreateStore";
import CategorySeoSelector from "../../../Category/SEO/categorySeoSelector";
import DescriptionItem from "./DescriptionItem/DescriptionItem";
import ItemCategoryAttrModels from "./ItemCategoryAttrModels";
import ItemCategoryCommandNew from "./ItemCategoryCommandNew";
import ItemComboSet from "./ItemComboSet";
import ItemCommand from "./ItemCommand";
import ItemConfig from "./ItemConfig";
import ItemImageCommand from "./ItemImageCommand";
import ItemProductAddonItem from "./ItemProductAddonItem";
import ItemTechnicalCommonCommand from "./ItemTechnicalCommonCommand";
import { useLocation, useParams } from "react-router-dom";

const CreateViewProduct = () => {
  const location = useLocation();
  const { id } = useParams();
  const type = location?.state && location?.state?.type;
  const itemCode = location?.state && location?.state?.itemCode;
  const initialTab = location?.state && location?.state?.initialTab;
  const [visible, { close, open }] = useDisclosure(false);
  const [activeTab, setActiveTab] = useState<string>(initialTab || "info1"); // tab mặc định hoặc từ props

  const {
    dataItemBase,
    dataItemCategory,
    dataItemSeo,
    dataItemTechnical,
    dataItemCategoryAttrModel,
    dataItemYoutube,
    dataItemImage,
    dataItemTagIds,
    setDataItemBase,
    setDataItemCategory,
    setDataItemTechnical,
    setDataItemCategoryAttrModel,
    setDataItemYoutube,
    setDataItemImage,
    resetState,
  } = useProductCreateStore();

  const removeSpecificKeys = (obj: any, keysToRemove: string[]) => {
    const result: any = {};
    for (const key in obj) {
      if (!keysToRemove.includes(key)) {
        result[key] = obj[key];
      }
    }
    return result;
  };

  useEffect(() => {
    // Các key cần loại bỏ
    const keysToRemove = [
      "tblItemSeoModels",
      "tblItemCategoryModels",
      // "tblItemImageModels",
      "tblItemCategoryAttrModels",
      "tblItemYoutubeModels",
      "tblItemTechnicalCommonModels",
      "tblTagItemModels",
    ];
    const callApiGetData = async () => {
      const callApi = await getDataDetailProduct(`?id=${id}`);
      if (!isNullOrUndefined(callApi) && !isNullOrUndefined(callApi?.data)) {
        const dataApi = callApi?.data;
        if (dataApi != null && !isNullOrUndefined(dataApi)) {
          if (dataApi) {
            // lọc lấy giá trị chỉ riêng cho tab cơ bản
            const dataItemCommand = removeSpecificKeys(dataApi, keysToRemove);
            //set giá trị cho tab danh muc
            setDataItemBase(dataItemCommand);
            setDataItemCategory(dataApi?.tblItemCategoryModels);
            setDataItemCategoryAttrModel(dataApi?.tblItemCategoryAttrModels);
            setDataItemTechnical(dataApi?.tblItemTechnicalCommonModels);
            setDataItemYoutube(dataApi?.tblItemYoutubeModels);
            setDataItemImage(dataApi?.tblItemImageModels);
          }
        } else {
          NotificationExtension.Fails("Dữ liệu không tồn tại");
          modals.closeAll();
        }
      } else {
        NotificationExtension.Fails("Dữ liệu không tồn tại");
        modals.closeAll();
      }
    };
    if (id) {
      callApiGetData();
    } else {
      resetState();
    }
  }, [
    id,
    setDataItemBase,
    setDataItemCategory,
    setDataItemTechnical,
    setDataItemYoutube,
    setDataItemCategoryAttrModel,
    resetState,
  ]);

  // useEffect(() => {
  //   if (activeTab === "info6") {
  //     // Các key cần loại bỏ
  //     const keysToRemove = [
  //       "tblItemSeoModels",
  //       "tblItemCategoryModels",
  //       // "tblItemImageModels",
  //       "tblItemCategoryAttrModels",
  //       "tblItemYoutubeModels",
  //       "tblItemTechnicalCommonModels",
  //       "tblTagItemModels",
  //     ];
  //     const callApiGetData = async () => {
  //       const callApi = await getDataDetailProduct(`?id=${id}`);
  //       if (!isNullOrUndefined(callApi) && !isNullOrUndefined(callApi?.data)) {
  //         const dataApi = callApi?.data;
  //         if (dataApi != null && !isNullOrUndefined(dataApi)) {
  //           if (dataApi) {
  //             // lọc lấy giá trị chỉ riêng cho tab cơ bản
  //             const dataItemCommand = removeSpecificKeys(dataApi, keysToRemove);
  //             //set giá trị cho tab danh muc
  //             setDataItemBase(dataItemCommand);
  //             setDataItemCategory(dataApi?.tblItemCategoryModels);
  //             setDataItemCategoryAttrModel(dataApi?.tblItemCategoryAttrModels);
  //             setDataItemTechnical(dataApi?.tblItemTechnicalCommonModels);
  //             setDataItemYoutube(dataApi?.tblItemYoutubeModels);
  //             setDataItemImage(dataApi?.tblItemImageModels);
  //           }
  //         } else {
  //           NotificationExtension.Fails("Dữ liệu không tồn tại");
  //           modals.closeAll();
  //         }
  //       } else {
  //         NotificationExtension.Fails("Dữ liệu không tồn tại");
  //         modals.closeAll();
  //       }
  //     };
  //     if (id) {
  //       callApiGetData();
  //     } else {
  //       resetState();
  //     }
  //   }
  // }, [activeTab]);

  // Check for tab parameter from URL and set active tab accordingly

  useEffect(() => {
    // Check if tab parameter was passed from the parent component
    const queryParams = new URLSearchParams(window.location.search);
    const tabParam = queryParams.get("tab");

    if (
      tabParam &&
      [
        "info1",
        "info2",
        "info5",
        "info6",
        "info7",
        "info8",
        "info9",
        "info10",
        "info11",
      ].includes(tabParam)
    ) {
      setActiveTab(tabParam);
    }
  }, []);

  // Check for initialTab and set the active tab
  useEffect(() => {
    console.log("CreateView: checking initialTab", initialTab);

    if (
      initialTab &&
      [
        "info1",
        "info2",
        "info5",
        "info6",
        "info7",
        "info8",
        "info9",
        "info10",
        "info11",
      ].includes(initialTab)
    ) {
      setTimeout(() => {
        setActiveTab(initialTab);
      }, 100);
    }
  }, [initialTab]);

  return (
    <div style={{ width: "100%" }}>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
        style={{ position: "relative" }}
      />
      {/* {id && !isCopy ? (
        <Group justify="center" mt="md" mb="md" maw={1200} mx="auto">
          <Button
            color="blue"
            variant="filled"
            onClick={() => {
              // Copy all product data from store, reset id, and switch to add mode
              const {
                dataItemBase,
                dataItemCategory,
                dataItemSeo,
                dataItemTechnical,
                dataItemCategoryAttrModel,
                dataItemYoutube,
                dataItemImage,
                dataItemTagIds,
                setDataItemBase,
                setDataItemCategory,
                setDataItemSeo,
                setDataItemTechnical,
                setDataItemCategoryAttrModel,
                setDataItemYoutube,
                setDataItemImage,
                setDataItemTagIds,
              } = useProductCreateStore.getState();
              setDataItemBase({
                ...dataItemBase,
                id: 0,
                itemName: dataItemBase?.itemName
                  ? dataItemBase.itemName + " COPY"
                  : "",
                itemCode: dataItemBase?.itemCode
                  ? dataItemBase.itemCode + " COPY"
                  : "",
              });
              setDataItemCategory([...dataItemCategory]);
              setDataItemSeo([...dataItemSeo]);
              setDataItemTechnical([...dataItemTechnical]);
              setDataItemCategoryAttrModel([...dataItemCategoryAttrModel]);
              setDataItemYoutube([...dataItemYoutube]);
              setDataItemImage([...dataItemImage]);
              setDataItemTagIds([...dataItemTagIds]);
              setIsCopy(true);
              window.history.replaceState(
                {},
                document.title,
                window.location.pathname
              );
            }}
          >
            Tạo sp copy
          </Button>
        </Group>
      ) : (
        <Group justify="center" mt="md" mb="md" maw={1200} mx="auto"></Group>
      )} */}
      <Tabs
        value={activeTab}
        onChange={(value) => {
          console.log("value", value);
          setActiveTab(value || "info1");
        }}
        style={{ position: "relative" }}
      >
        <Tabs.List>
          <Tabs.Tab value="info1">Cơ bản</Tabs.Tab>
          <Tabs.Tab value="info6">Mô tả</Tabs.Tab>
          <Tabs.Tab value="info2">Danh mục</Tabs.Tab>
          {/* <Tabs.Tab value="info11">Danh mục cho SEO</Tabs.Tab> */}
          {/* <Tabs.Tab value="info4">Nhóm thông số kỹ thuật</Tabs.Tab> */}
          <Tabs.Tab value="info5">Bộ lọc thuộc tính</Tabs.Tab>
          {/* <Tabs.Tab value="info6">Youtube</Tabs.Tab> */}
          <Tabs.Tab value="info7">Ảnh sản phẩm</Tabs.Tab>
          <Tabs.Tab value="info8">Combo set</Tabs.Tab>
          <Tabs.Tab value="info9">Cấu hình</Tabs.Tab>
          <Tabs.Tab value="info10">Dịch vụ/SP đi kèm</Tabs.Tab>
        </Tabs.List>

        <div
          style={{
            pointerEvents: type === "detail" ? "none" : "auto",
          }}
        >
          {/* ✅ Chỉ render tab đang active */}
          {activeTab === "info1" && (
            <Tabs.Panel value="info1">
              <ItemCommand />
            </Tabs.Panel>
          )}
          {activeTab === "info6" && (
            <Tabs.Panel value="info6">
              <DescriptionItem />
            </Tabs.Panel>
          )}
          {activeTab === "info2" && (
            <Tabs.Panel value="info2">
              <ItemCategoryCommandNew infor3={activeTab} />
            </Tabs.Panel>
          )}
          {activeTab === "info4" && (
            <Tabs.Panel value="info4">
              <ItemTechnicalCommonCommand />
            </Tabs.Panel>
          )}
          {activeTab === "info5" && (
            <Tabs.Panel value="info5">
              <ItemCategoryAttrModels />
            </Tabs.Panel>
          )}
          {activeTab === "info7" && (
            <Tabs.Panel value="info7">
              <ItemImageCommand />
            </Tabs.Panel>
          )}
          {activeTab === "info8" && (
            <Tabs.Panel value="info8">
              <ItemComboSet id={id} />
            </Tabs.Panel>
          )}
          {activeTab === "info9" && (
            <Tabs.Panel value="info9">
              <ItemConfig id={id} itemcode={itemCode} />
            </Tabs.Panel>
          )}
          {activeTab === "info10" && (
            <Tabs.Panel value="info10">
              <ItemProductAddonItem id={id} />
            </Tabs.Panel>
          )}
          {activeTab === "info11" && (
            <Tabs.Panel value="info11">
              <CategorySeoSelector
                selectedIds={(dataItemSeo || []).map((item: any) => item.id)} // Lấy từ store
                onSelectionChange={(selectedIds) => {
                  // Cập nhật store với danh sách ID đã chọn
                  const { setDataItemSeo } = useProductCreateStore.getState();
                  setDataItemSeo(selectedIds.map((id: number) => ({ id })));
                }}
              />
            </Tabs.Panel>
          )}
          {/* {activeTab === "info6" && (
          <Tabs.Panel value="info6">
            <ItemYoutubeCommand />
          </Tabs.Panel>
        )} */}
        </div>
      </Tabs>

      {/* <Group
        justify="center"
        mt="lg"
        p="10px 0"
        style={{ position: "sticky", bottom: 0, backgroundColor: "white" }}
      >
        <Button
          type="button"
          color="#3598dc"
          loading={visible}
          onClick={id && !isCopy ? handleEditProduct : handleCreateProduct}
          leftSection={<IconPlus size={18} />}
        >
          {id && !isCopy ? "Sửa sản phẩm" : "Thêm sản phẩm"}
        </Button>
      </Group> */}
    </div>
  );
};

export default CreateViewProduct;
